import { addSignTypeApi, updateSignTypeApi } from '@/services/signAndPayment';
import { Form, Input, Modal, Switch, message } from 'antd';
import './index.less';

interface ModalProps {
  data: any;
  visible: boolean;
  editType: number;
  handleCancel: () => void;
}
const SignTypeModal = (props: ModalProps) => {
  const { data, visible, editType, handleCancel } = props;
  const [form] = Form.useForm();

  const onHandleSubmit = async (data: any) => {
    if (editType === 0) {
      const res = await addSignTypeApi(data);
      if (res.data && res.data.code === 'SUCCESS' && res.code === 200) {
        message.info('添加成功');
        handleCancel();
      }
    } else {
      const res = await updateSignTypeApi(data.type, data);
      if (res.data && res.data.code === 'SUCCESS' && res.code === 200) {
        message.info('更新成功');
        handleCancel();
      }
    }
  };

  const handleFormSubmit = () => {
    form.validateFields().then(async (values) => {
      onHandleSubmit(values);
    });
  };

  return (
    <Modal
      open={visible}
      title={editType === 1 ? '编辑签约平台' : '新增签约平台'}
      maskClosable={false}
      onCancel={handleCancel}
      onOk={handleFormSubmit}
    >
      <Form
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        style={{ maxWidth: 600 }}
        form={form}
        initialValues={data}
      >
        <Form.Item
          label="签约平台名称"
          name="name"
          rules={[{ required: true, message: '请输入签约平台名称' }]}
        >
          <Input placeholder="请输入签约平台名称" />
        </Form.Item>
        <Form.Item
          label="签约平台标识"
          name="type"
          rules={[{ required: true, message: '请输入签约平台标识' }]}
        >
          <Input disabled={editType === 1} placeholder="请输入签约平台标识" />
        </Form.Item>
        <Form.Item label="签约平台接口域名" name="domain">
          <Input placeholder="签约平台接口域名" />
        </Form.Item>
        <Form.Item label="签约平台地址" name="url">
          <Input placeholder="签约平台地址" />
        </Form.Item>
        {/* <Form.Item label="启用状态" name="status">
          <Switch
            checkedChildren="启用"
            unCheckedChildren="禁用"
            defaultChecked={data.status === 1}
          />
        </Form.Item> */}
      </Form>
    </Modal>
  );
};
export default SignTypeModal;
